import Cookies from 'js-cookie';
import { CoreHelperMessages, Log, mergeDeepWithDefault } from '../core';
export class CookieStorage {
    get length() {
        return Object.keys(Cookies.get()).length;
    }
    constructor(cookiesStorageParams) {
        this.credentialsDomain = '';
        this.path = '';
        this.secure = true;
        const cookiesDefaultOptions = {
            credentialsDomain: typeof window === 'undefined' ? '' : window.location.hostname,
            expiresAt: 2 * 60 * 60 * 1000,
            secure: true,
            path: '',
            sameSite: 'Strict',
        };
        const params = mergeDeepWithDefault(cookiesDefaultOptions, cookiesStorageParams || {});
        if (params.expiresAt !== undefined) {
            this.expiresAt = params.expiresAt;
        }
        this.credentialsDomain = params.credentialsDomain;
        this.secure = params.secure;
        this.path = params.path;
        this.sameSite = params.sameSite;
    }
    key(_index) {
        Log.error('[cookieStorage.key] Method not implemented');
        // to be implemented?
        return null;
    }
    keys() {
        return Object.keys(Cookies.get());
    }
    setItem(name, value) {
        // Log.info('[cookieStorage.setItem]', name, value);
        this.checkLimit(value);
        const attributes = {
            domain: this.credentialsDomain,
            secure: this.secure,
            path: this.path,
            sameSite: this.sameSite,
        };
        if (this.expiresAt) {
            attributes.expires = new Date(Date.now() + this.expiresAt);
        }
        Cookies.set(name, value, attributes);
    }
    getItem(name) {
        const value = Cookies.get(name) || null;
        // Log.info('[cookieStorage.getItem]', name, value);
        return value;
    }
    removeItem(name) {
        // Log.info('[cookieStorage.removeItem]', name);
        Cookies.remove(name, {
            domain: this.credentialsDomain,
            secure: this.secure,
            path: this.path,
            sameSite: this.sameSite,
        });
    }
    clear() {
        Log.log('[cookieStorage.clear] Remove al cookies from this domain and config');
        Object.keys(Cookies.get()).forEach(name => this.removeItem(name));
    }
    checkLimit(value) {
        const size = new Blob([encodeURIComponent(value)]).size;
        if (size > 4000 /* 96 of margin of error */) {
            Log.warn(CoreHelperMessages.CORE_COOKIES_MAX_BYTES);
        }
    }
}
export const cookieStorage = new CookieStorage();
//# sourceMappingURL=cookieStorage.js.map